// import logo from "./logo.svg";
import "./App.css";
import Routing from "./components/Routing/Routing";
import { MyProvider, useMyContext } from "./context/MyContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-tooltip/dist/react-tooltip.css'
import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import InactivityHandler from "./components/InactivityHandler";
import { CurrencyProvider } from "./context/CurrencyContext"; // Import the new context
import { TradeOSProvider } from "./context/TradeOSContext";
import '@toast-ui/editor/dist/toastui-editor.css'; // Styles for the Toast UI Editor.  DO NOT REMOVE


const queryClient = new QueryClient();

function AppContent() {
  const { checkAuthStatus } = useMyContext();

  React.useEffect(() => {
    if (checkAuthStatus) {
      checkAuthStatus();
    }
  }, [checkAuthStatus]);

  return (
    <InactivityHandler>
      <div className="min-h-screen">
        <ToastContainer />
        <Routing />
      </div>
    </InactivityHandler>
  );
}

function App() {



  return (
    <>
      <QueryClientProvider client={queryClient}>
        <MyProvider>
          <CurrencyProvider>
            <TradeOSProvider>
              <BrowserRouter>
                <AppContent />
              </BrowserRouter>
            </TradeOSProvider>
          </CurrencyProvider>
        </MyProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
